export const APP_NAME = 'portal';

export const MENU_ID_TRANSACTION_READ = 1;
export const MENU_ID_USER_MANAGEMENT = 11;
export const MENU_ID_PARTNER_MANAGEMENT = 12;
export const MENU_ID_PRODUCT_MANAGEMENT = 21;
export const MENU_ID_CONFIG_MANAGEMENT = 22;
export const MENU_ID_PRODUCT_SELECT_HUB = 23;
export const MENU_ID_HUB_MANAGEMENT = 31;
export const MENU_ID_AUDIT = 24;
export const MENU_ID_REQUEST_MSG = 41;
export const CREATE_MODE = "CREATE";
export const READ_MODE = "READ";
export const UPDATE_MODE = "UPDATE";
export const DELETE_MODE = "DELETE";

export const PATH_USER_SEARCH_OR_CREATE = "/api/v1/portal/users"
export const PATH_USER_READ_UPDATE = `${PATH_USER_SEARCH_OR_CREATE}/{0}`
export const PATH_PARTNER_USERS = '/api/v1/auth/partner/users';

export const PM_CREATE_USER = 39;
export const PM_UPDATE_USER = 41;
export const PM_UPDATE_PRODUCT = 42;

export const PM_ADMIN_UPDATE_PRODUCT = 54;
export const PM_VIEW_TRANSACTION_DETAIL = 80;
export const PM_TRANSACTION_QUERY = 83;

export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';

export const ACTIVATE = 'ACTIVATE';
export const DEACTIVATE = 'DEACTIVATE';

export const PARTNER_TELEPIN = 'TELEPIN';
export const PARTNER_THUNES = 'THUNES';
export const PARTNER_TRANGLO = 'TRANGLO';
export const PARTNER_WU = 'WU';
export const PARTNER_NETCLICK = 'NETCLICK';

export const PARTNER_ID_SEARCH_ALLOWED = ['2', '3', '5'];
export const PARTNER_OPTIONS = [
    { key: "1", value: PARTNER_TELEPIN },
    { key: "2", value: PARTNER_WU},
    { key: "3", value: PARTNER_THUNES },
    { key: "5", value: PARTNER_TRANGLO }
]

export const PARTNERS = {
    '1': PARTNER_TELEPIN,
    '2': PARTNER_WU,
    '3': PARTNER_THUNES,
    '5': PARTNER_TRANGLO
}

export const PARTNERS_FOR_SELECT_HUB = {
    '1': `${PARTNER_TELEPIN}(${PARTNER_TRANGLO})`,
    '2': PARTNER_WU,
    '3': PARTNER_THUNES,
    '5': PARTNER_TRANGLO
}

export const BANK_ACCOUNT = 'BANK ACCOUNT';
export const CASH_PICKUP = 'CASH PICKUP';
export const EWALLET = 'E-WALLET';

export const SERVICE_TYPES = {
    '1': BANK_ACCOUNT,
    '2': CASH_PICKUP,
    '3': EWALLET,
}

export const ISSUER_ML_ONLY = 'ISSUER_ML_ONLY';
export const CORRIDOR_REFERENCE_ONLY = 'CORRIDOR_REFERENCE_ONLY';
export const BOTH = 'BOTH';

export const BANK_UPDATE_TYPE = {
    '1': ISSUER_ML_ONLY,
    '2': CORRIDOR_REFERENCE_ONLY,
    '3': BOTH,
}

export const FLOW_UPDATE_BANK_STATUS= 'UPDATE_BANK_STATUS'
export const FLOW_NAME_SELECT_HUB = 'SELECT_HUB'
export const FLOW_NAME_UPDATE_TIE_FEE = 'UPDATE_TIE_FEE'

export const ROLE_ID_CHECKER = 18;
export const ROLE_ID_MAKER = 17;
export const ROLE_ID_WRITE_PRODUCT_SETTING = 14;
export const ROLE_ID_PARTNER_MANAGEMENT = 23;

export const MENU_ROLES_REQUIRED_SELECT_HUB = [ROLE_ID_MAKER, ROLE_ID_WRITE_PRODUCT_SETTING];


export const DATE_TIME_FORMAT_ISO = "YYYY-MM-DDTHH:mm:ss";
export const DATE_TIME_FORMAT_SIMPLE = "YYYY-MM-DD HH:mm";
export const TIME_ZONE_SGT = "Asia/Singapore";

export const REQUEST_STATUS_CREATED = 'CREATED';

// Partner defaults
// There is only one partner today. Change this value if a new partner is added.
export const DEFAULT_PARTNER_ID = 'partner';